import { render, staticRenderFns } from "./ot-profile-layout.vue?vue&type=template&id=bfdc529c&scoped=true&"
import script from "./ot-profile-layout.vue?vue&type=script&lang=ts&"
export * from "./ot-profile-layout.vue?vue&type=script&lang=ts&"
import style0 from "./ot-profile-layout.vue?vue&type=style&index=0&id=bfdc529c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfdc529c",
  null
  
)

export default component.exports